export default __webpack_public_path__ + "static/media/2.46b125a8.jpg";